import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class AssignmentService {
	constructor(private http: HttpClient) {}

	loadHtml(submissionId) {
		return this.http.get<any>(
			`${environment.url.cohort}/assignment/submission/${submissionId}/html`,
		);
	}

	saveHtml(submissionId, content) {
		return this.http.post(
			`${environment.url.cohort}/assignment/submission/${submissionId}/html`,
			{ content },
		);
	}

	saveAssignment(email: string, submissionId: string) {
		return this.http.post(`${environment.url.cohort}/v2/submitAssignment`, {
			email,
			isPublic: true,
			submissionId,
			tags: [],
			url: `https://vyas-dev.terra.do/#/login/auth?returnUrl=assignment/${submissionId}/readOnly`,
		});
	}
}
